import React, { useEffect, useMemo, useState } from 'react';
import { useFormContext } from '../../formProvider';
import Sifg from '../../vymoComponentsWithForm/sifg';
import {
  getSifgInputsForProfileSelection,
  getSifgOptionsForProfileSelection,
} from './queries';

function ProfileFieldAdapter(props: any) {
  const { subTypes = {}, value: valueProp, onChange } = props;
  const { formValue, getProfileDetails } = useFormContext(false);

  const profileDetails = useMemo(
    () => getProfileDetails() ?? [],
    [getProfileDetails],
  );

  const profileValue = profileDetails.find(
    (profile) => profile.isPrimary,
  )?.profileId;
  const [value, setValue] = useState<string>(valueProp);

  useEffect(() => {
    if (profileValue !== valueProp) {
      setValue(profileValue);
      onChange(profileValue);
    }
  }, [onChange, profileValue, valueProp]);

  const sifgOptions = useMemo(
    () => getSifgOptionsForProfileSelection(profileDetails),
    [profileDetails],
  );
  const sifgInputs = useMemo(
    () => getSifgInputsForProfileSelection(subTypes, profileDetails, formValue),
    [formValue, profileDetails, subTypes],
  );

  const sifgConfig = {
    ...props,
    options: {
      selection: {
        ...props,
        type: 'code_name_spinner',
        code_name_spinner_options: sifgOptions,
        required: true,
      },
      inputs: sifgInputs,
    },
    type: 'sifg',
    meta: {
      viewType: 'select',
    },
    value,
    outputType: { returnCode: true },
  };

  return <Sifg {...sifgConfig} />;
}

export default React.memo(ProfileFieldAdapter);
